import { initialCustomFormFieldsState } from "./CustomFormFields.types";
import { LoadState } from "../../constants/enums";
import { createSlice } from "@reduxjs/toolkit";
import { fetchCustomFormFieldsList, fetchDynamicFormTemplatesList, fetchAllQuestionnaires } from "./CustomFormFieldsActions";

const customFormFieldsSlice = createSlice({
  name: "customFormFields",
  initialState: initialCustomFormFieldsState,
  reducers: {
    clearCustomFormFieldsState: (state) => {
      return initialCustomFormFieldsState;
    },
    clearDynamicFormTemplatesState: (state) => {
      state.templates = initialCustomFormFieldsState.templates;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomFormFieldsList.pending, (state) => {
        state.data.loading = LoadState.InProgress;
        state.data.list = [];
      })
      .addCase(fetchCustomFormFieldsList.fulfilled, (state, action) => {
        state.data.loading = LoadState.Loaded;
        state.data.list = action.payload.data;
      })
      .addCase(fetchCustomFormFieldsList.rejected, (state) => {
        state.data.loading = LoadState.Failed;
        state.data.list = [];
      })
      .addCase(fetchDynamicFormTemplatesList.pending, (state) => {
        state.templates.loading = LoadState.InProgress;
        state.templates.list = [];
      })
      .addCase(fetchDynamicFormTemplatesList.fulfilled, (state, action) => {
        state.templates.loading = LoadState.Loaded;
        state.templates.list = action.payload.data;
      })
      .addCase(fetchDynamicFormTemplatesList.rejected, (state) => {
        state.templates.loading = LoadState.Failed;
        state.templates.list = [];
      })
      .addCase(fetchAllQuestionnaires.pending, (state) => {
        state.allQuestionnaires.loading = LoadState.InProgress;
        state.allQuestionnaires.list = [];
      })
      .addCase(fetchAllQuestionnaires.fulfilled, (state, action) => {
        state.allQuestionnaires.loading = LoadState.Loaded;
        state.allQuestionnaires.list = action.payload.data;
      })
      .addCase(fetchAllQuestionnaires.rejected, (state) => {
        state.allQuestionnaires.loading = LoadState.Failed;
        state.allQuestionnaires.list = [];
      });
  },
});

export const { clearCustomFormFieldsState, clearDynamicFormTemplatesState } = customFormFieldsSlice.actions;
export const CustomFormFieldsReducer = customFormFieldsSlice.reducer;
